import React, { useState } from "react";
import {
    Modal,
    Box,
    Grid,
    Typography,
    Radio,
    RadioGroup,
    FormControlLabel,
    Checkbox,
    TextField,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    CircularProgress,
    Backdrop,
} from "@mui/material";
import ConfirmationModal from "../../../../common/components/ConfirmationModal";
import CancelPresentationIconButton from "../../../../common/components/Buttons/CancelPresentationIconButton";
import { BedSoreAuditListing, postBedSoreAudit } from "../../../services/cliinicalChartServices/AllAuditServices";
import CommonDynamicTablePaginationNew from "../../../../common/components/CommonTable/CommonDynamicTablePaginationNew";
import { successAlert } from "../../../../common/components/Toasts/Toasts";
// import { postBedSoreAudit } from "../../services/Sample/BedSoreAuditServices";

const ModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxHeight: "90vh",
    overflow: "auto",
    bgcolor: "background.paper",
    border: "1px solid gray",
    borderRadius: 2,
    boxShadow: 20,
    p: 3,
};

export default function BedSoreAuditModel(props) {

    const [auditData, setAuditData] = useState({
        selectedOptions: [],
    });

    const [openPost, setOpenPost] = useState(false);
    const [pendingData, setPendingData] = useState(null);
    const [dataResult, setDataResult] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [count, setCount] = useState(0);
    const [loading, setLoading] = useState(false);
const userInfo=JSON.parse(localStorage?.getItem("userInfo"))
console.log("userInfouserInfouserInfo",userInfo?.userId);
    const handleOpenPost = () => {
        setOpenPost(true);
    };

    const handleClosePost = () => {
        setOpenPost(false);
    };

    const handleStatusChange = (value) => {
        setAuditData((prev) => {
            const alreadySelected =
                prev.selectedOptions.includes(value);

            return {
                ...prev,
                selectedOptions: alreadySelected
                    ? prev.selectedOptions.filter(
                        (item) => item !== value
                    )
                    : [...prev.selectedOptions, value],
            };
        });
    };

    const [tableData, setTableData] = useState([]);
    const handleIncompleteReasonChange = (index, value) => {
        const updated = [...auditData];
        updated[index].incompleteReason = value;
        setAuditData(updated);
    };

    const handleNotDoneReasonChange = (index, value) => {
        const updated = [...auditData];
        updated[index].notDoneReason = value;
        setAuditData(updated);
    };

    const handleSubmit = () => {

        const saveObj = {

            bedSoreSkinAssessment:
                auditData.selectedOptions.includes(
                    "Skin Assessment"
                ),
            bedSorePositioning:
                auditData.selectedOptions.includes(
                    "Positioning"
                ),
            bedSorePushTool:
                auditData.selectedOptions.includes(
                    "Push Tool"
                ),
            bedSoreDressingApplied:
                auditData.selectedOptions.includes(
                    "Dressing Applied"
                ),
            bedSoreNA:
                auditData.selectedOptions.includes(
                    "Not Applicable"
                ),
           admissionId: props?.getpatientVisitId,
            addedBy: userInfo?.userId,
        };

        setPendingData(saveObj);

        handleOpenPost();
    };

    const addRecord = async () => {

        const saveObj = {

            bedSoreSkinAssessment:
                auditData.selectedOptions.includes(
                    "Skin Assessment"
                ),
            bedSorePositioning:
                auditData.selectedOptions.includes(
                    "Positioning"
                ),
            bedSorePushTool:
                auditData.selectedOptions.includes(
                    "Push Tool"
                ),
            bedSoreDressingApplied:
                auditData.selectedOptions.includes(
                    "Dressing Applied"
                ),
            bedSoreNA:
                auditData.selectedOptions.includes(
                    "Not Applicable"
                ),
          admissionId: props?.getpatientVisitId,
            addedBy: userInfo?.userId,
        };

        console.log("API CALLING");

        setLoading(true);

        try {

            const response =
                await postBedSoreAudit(
                    saveObj
                );
            console.log(
                "API Response :",
                response.data
            );
            successAlert(
                response?.data?.result
            );
            handleClear();
            populateTable();
            handleClosePost();

        } catch (error) {

            console.error(
                "API Error :",
                error
            );

        } finally {
            setLoading(false);
        }
    };

    const populateTable = async () => {

        try {

            const response =
                await BedSoreAuditListing(props?.getpatientVisitId);

            console.log(
                "Listing Response :",
                response.data
            );

            const formattedData =
                response?.data?.result?.map(
                    (item) => ({
                        ...item,

                        BedSoreSkinAssessment:
                            item.BedSoreSkinAssessment === true
                                ? <span style={{ color: "green", fontWeight: "bold" }}>✔</span>
                                : "",

                        BedSorePositioning:
                            item.BedSorePositioning === true
                                ? <span style={{ color: "green", fontWeight: "bold" }}>✔</span>
                                : "",

                        BedSorePushTool:
                            item.BedSorePushTool === true
                                ? <span style={{ color: "green", fontWeight: "bold" }}>✔</span>
                                : "",

                        BedSoreDressingApplied:
                            item.BedSoreDressingApplied === true
                                ? <span style={{ color: "green", fontWeight: "bold" }}>✔</span>
                                : "",

                        BedSoreNA:
                            item.BedSoreNA === true
                                ? <span style={{ color: "green", fontWeight: "bold" }}>✔</span>
                                : "",
                    })
                );

            setDataResult(
                formattedData || []
            );

        } catch (error) {

            console.error(
                "Listing Error :",
                error
            );
        }
    };

    React.useEffect(() => {
        populateTable();
    }, []);

    const handleClear = () => {
        setAuditData({
            selectedOptions: [],
        });
    };

    return (
        <div>
            <Modal open={props.open}
                onClose={props.handleClose}>
                <Box sx={ModalStyle}>
                    <CancelPresentationIconButton onClick={props.handleClose} />

                    <fieldset className="text-left py-2 rounded border border-grey-100 p-3">
                        <legend className="px-3 font-bold text-gray-800">
                            Bed Sore Audit
                        </legend>

                        <div
                            style={{
                                display: "flex",
                                gap: "20px",
                                width: "100%",
                                marginTop: "10px",
                            }}
                        >

                            <div
                                style={{
                                    width: "30%",
                                    border: "1px solid #dcdcdc",
                                    borderRadius: "10px",
                                    padding: "20px",
                                    display: "flex",
                                    flexDirection: "column",
                                    // height: "420px",
                                }}
                            >
                                <Typography
                                    variant="h6"
                                    sx={{
                                        mb: 2, fontWeight: "bold", fontSize: "18px",
                                    }}
                                >
                                    Bed Sore
                                </Typography>

                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "flex-start",
                                        gap: "1px",
                                    }}
                                >

                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={auditData.selectedOptions.includes(
                                                    "Skin Assessment"
                                                )}
                                                onChange={() =>
                                                    handleStatusChange("Skin Assessment")
                                                }
                                            />
                                        }
                                        label="Skin Assessment"
                                    />

                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={auditData.selectedOptions.includes(
                                                    "Positioning"
                                                )}
                                                onChange={() =>
                                                    handleStatusChange("Positioning")
                                                }
                                            />
                                        }
                                        label="Positioning"
                                    />

                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={auditData.selectedOptions.includes(
                                                    "Push Tool"
                                                )}
                                                onChange={() =>
                                                    handleStatusChange("Push Tool")
                                                }
                                            />
                                        }
                                        label="Push Tool"
                                    />

                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={auditData.selectedOptions.includes(
                                                    "Dressing Applied"
                                                )}
                                                onChange={() =>
                                                    handleStatusChange("Dressing Applied")
                                                }
                                            />
                                        }
                                        label="Dressing Applied"
                                    />

                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={auditData.selectedOptions.includes(
                                                    "Not Applicable"
                                                )}
                                                onChange={() =>
                                                    handleStatusChange("Not Applicable")
                                                }
                                            />
                                        }
                                        label="Not Applicable"
                                    />

                                </div>

                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        gap: "10px",
                                        marginTop: "auto",
                                        paddingTop: "10px",
                                    }}
                                >

                                    <button
                                        onClick={handleClear}
                                        style={{
                                            padding: "6px 15px",
                                            border: "1px solid red",
                                            backgroundColor: "white",
                                            color: "red",
                                            borderRadius: "5px",
                                            cursor: "pointer",
                                            fontSize: "14px",
                                            fontWeight: "500",
                                        }}
                                    >
                                        Clear
                                    </button>

                                    <button
                                        onClick={handleSubmit}
                                        style={{
                                            padding: "7px 15px",
                                            border: "none",
                                            backgroundColor: "#22c55e",
                                            color: "white",
                                            borderRadius: "5px",
                                            cursor: "pointer",
                                            fontSize: "14px",
                                            fontWeight: "500",
                                        }}
                                    >
                                        Submit
                                    </button>

                                </div>
                            </div>

                            <div
                                style={{
                                    width: "70%",
                                }}
                            >

                                <Typography
                                    variant="h6"
                                    sx={{ fontWeight: "bold", fontSize: "18px", }}
                                >
                                    Bed Sore Audit Trail
                                </Typography>

                                {
                                    dataResult?.length > 0 ? (
                                        <div
                                            style={{
                                                height: "320px",
                                                overflow: "auto",
                                                border: "1px solid #d1d5db",
                                                borderRadius: "6px",
                                                padding: 0,
                                                margin: 0,
                                            }}
                                        >
                                            <CommonDynamicTablePaginationNew
                                                dataResult={dataResult}
                                                renderActions={() => null}
                                                removeHeaders={["id"]}
                                                populateTable={populateTable}
                                                actionsRequired={false}
                                                highlightRow={false}
                                                page={page}
                                                setPage={setPage}
                                                rowsPerPage={rowsPerPage}
setRowsPerPage={setRowsPerPage}
count={dataResult?.length}
setCount={dataResult?.length}
/>
                                        </div>
                                    ) : (
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                height: "300px",
                                                fontSize: "16px",
                                                color: "#9ca3af",
                                            }}
                                        >
                                            No Records Found...
                                        </div>
                                    )
                                }

                            </div>
                        </div>

                    </fieldset>
                </Box>
            </Modal>

            <Backdrop
                sx={{
                    color: "#fff",
                    zIndex: 9999,
                }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <ConfirmationModal
                confirmationOpen={openPost}
                confirmationHandleClose={handleClosePost}
                confirmationSubmitFunc={addRecord}
                confirmationLabel="Confirmation"
                confirmationMsg="Are you sure you want to submit this record ?"
                confirmationButtonMsg="Submit"
            />
        </div>
    );
}